import type { enMenu } from '../en/menu';

export const idMenu: Record<keyof typeof enMenu, string> = {
  'menu.loading': 'Memuat menu…',
  'menu.error.notFound': 'Kode QR ini sudah tidak berlaku. Minta kode baru ke staf kami.',
  'menu.error.load': 'Menu tidak dapat dimuat. Periksa koneksi Anda.',
  'menu.retry': 'Coba lagi',
  'menu.table': 'Meja {table}',
  'menu.language': 'Bahasa',
  'menu.promos.title': 'Promo',
  'menu.promos.slide': 'Promo {index} dari {count}',
  'menu.promos.previous': 'Promo sebelumnya',
  'menu.promos.next': 'Promo berikutnya',
  'menu.promos.until': 'Sampai {date}',
  'menu.promos.see': 'Lihat di menu',
  'menu.categories.label': 'Kategori menu',
  'menu.empty': 'Menu belum tersedia. Silakan tanyakan ke staf kami.',
  'menu.prices': 'Harga belum termasuk biaya layanan {service}% dan pajak {tax}%.',
  'menu.pricesTaxOnly': 'Harga belum termasuk pajak {tax}%.',
  'menu.item.soldOut': 'HABIS',
  'menu.item.askWaiter': 'Untuk memesan, silakan panggil pelayan.',
  'menu.item.choices': 'Pilihan',
  'menu.item.required': 'Pilih {min}',
  'menu.item.upTo': 'Maksimal {max}',
  'menu.item.optional': 'Opsional',
  'menu.item.howToOrder': 'Untuk memesan, panggil pelayan kami — pesanan akan dikirim ke dapur.',
  'menu.item.close': 'Tutup',
  'menu.item.photoBy': 'Foto: {name}',
  'menu.bill.open': 'Tagihan & bayar',
  'menu.bill.openWithAmount': 'Tagihan · {amount}',
  'menu.bill.title': 'Tagihan',
  'menu.bill.subtitle': 'Meja {table} · {branch}',
  'menu.bill.back': 'Kembali ke menu',
  'menu.bill.loading': 'Memuat tagihan…',
  'menu.bill.error': 'Tagihan tidak dapat dimuat.',
  'menu.bill.noSession':
    'Belum ada tamu di meja ini. Setelah pelayan mengirim pesanan Anda ke dapur, pesanan muncul di sini.',
  'menu.bill.noItems':
    'Belum ada pesanan yang dikirim ke dapur. Item muncul di sini setelah pesanan dikirim.',
  'menu.bill.estimate': 'Perkiraan — tagihan final dibuat saat Anda membayar.',
  'menu.bill.number': 'Tagihan {number}',
  'menu.bill.items': 'Pesanan Anda',
  'menu.bill.subtotal': 'Subtotal',
  'menu.bill.service': 'Biaya layanan {rate}',
  'menu.bill.tax': 'Pajak {rate}',
  'menu.bill.rounding': 'Pembulatan',
  'menu.bill.total': 'Total',
  'menu.bill.paid': 'Sudah dibayar',
  'menu.bill.outstanding': 'Sisa tagihan',
  'menu.bill.updated': 'Diperbarui {time}',
  'menu.bill.refresh': 'Perbarui',
  'menu.bill.status.sent': 'Dikirim',
  'menu.bill.status.preparing': 'Disiapkan',
  'menu.bill.status.ready': 'Siap',
  'menu.bill.status.served': 'Disajikan',
  'menu.pay.cta': 'Bayar {amount} di aplikasi',
  'menu.pay.starting': 'Membuka pembayaran…',
  'menu.pay.continue': 'Lanjutkan pembayaran',
  'menu.pay.orCashier': 'Anda juga bisa membayar di kasir.',
  'menu.pay.disabled': 'Pembayaran di aplikasi belum tersedia di sini. Silakan bayar di kasir.',
  'menu.pay.nothing': 'Tidak ada lagi yang perlu dibayar. Terima kasih!',
  'menu.pay.secure':
    'Pembayaran Anda dikonfirmasi langsung oleh penyedia pembayaran, bukan oleh halaman ini.',
  'menu.pay.checking': 'Memeriksa pembayaran Anda…',
  'menu.pay.pending': 'Menunggu konfirmasi {amount} dari penyedia pembayaran.',
  'menu.pay.settled': 'Pembayaran {amount} diterima. Terima kasih!',
  'menu.pay.failed': 'Pembayaran gagal. Tidak ada dana yang ditarik — Anda bisa mencoba lagi.',
  'menu.pay.expired': 'Waktu pembayaran habis. Anda bisa mencoba lagi.',
  'menu.pay.cancelled': 'Pembayaran ini sudah diganti dengan yang lebih baru.',
  'menu.pay.refund':
    'Kami menerima {amount}, tetapi tagihan sudah lunas. Staf kami akan mengembalikan dana Anda — mohon beri tahu mereka.',
  'menu.pay.amountChanged': 'Tagihan berubah. Periksa total baru, lalu bayar lagi.',
  'menu.pay.sessionChanged':
    'Meja ini sudah berganti tamu. Muat ulang untuk melihat tagihan terkini.',
  'menu.pay.rateLimited': 'Terlalu banyak percobaan. Tunggu sebentar, lalu coba lagi.',
  'menu.pay.error': 'Pembayaran tidak dapat dimulai. Coba lagi atau bayar di kasir.',
  'menu.scan.title': 'Pindai kode QR di meja Anda',
  'menu.scan.description':
    'Setiap meja punya kode QR sendiri. Arahkan kamera ponsel ke kode tersebut untuk melihat menu dan tagihan Anda.',
  'menu.sim.badge': 'MODE UJI',
  'menu.sim.title': 'Simulator pembayaran',
  'menu.sim.description':
    'Pengganti penyedia pembayaran selama pengujian. Tidak ada uang yang berpindah. Hasilnya dikirim ke restoran sebagai callback bertanda tangan.',
  'menu.sim.merchant': 'Merchant',
  'menu.sim.amount': 'Jumlah',
  'menu.sim.expires': 'Bayar sebelum {time}',
  'menu.sim.pay': 'Simulasikan pembayaran berhasil',
  'menu.sim.fail': 'Simulasikan pembayaran gagal',
  'menu.sim.working': 'Mengirim…',
  'menu.sim.closed': 'Checkout ini sudah ditutup ({status}).',
  'menu.sim.back': 'Kembali ke tagihan',
  'menu.sim.notFound': 'Checkout ini tidak ditemukan.',
  // ---- Guest self-order (ADR-0029)
  'menu.item.quantity': 'Jumlah',
  'menu.item.decrease': 'Kurangi',
  'menu.item.increase': 'Tambah',
  'menu.item.notes': 'Catatan (opsional)',
  'menu.item.notesPlaceholder': 'mis. tidak pakai bawang',
  'menu.item.add': 'Tambah ke pesanan',
  'menu.item.chooseRequired': 'Pilih {group} dulu',
  'menu.item.added': '{name} ditambahkan ke pesanan',
  'menu.cart.open': 'Pesanan ({count})',
  'menu.cart.title': 'Pesanan Anda',
  'menu.cart.empty': 'Belum ada item — pilih dari menu.',
  'menu.cart.remove': 'Hapus {name}',
  'menu.cart.guests': 'Jumlah tamu',
  'menu.cart.subtotal': 'Subtotal',
  'menu.cart.taxNote': 'Pajak dan biaya layanan ditambahkan di tagihan.',
  'menu.cart.send': 'Kirim ke dapur',
  'menu.cart.sending': 'Mengirim…',
  'menu.cart.sent': 'Pesanan terkirim ke dapur.',
  'menu.cart.error': 'Pesanan belum terkirim. Silakan coba lagi.',
  'menu.cart.soldOut': 'Baru saja habis: {items}. Hapus lalu kirim lagi.',
  'menu.cart.tableUnavailable': 'Meja ini belum bisa menerima pesanan. Silakan panggil pelayan.',
  'menu.cart.rateLimited': 'Terlalu banyak pesanan dari meja ini. Tunggu sebentar.',
  'menu.cart.retry': 'Coba lagi',
  'menu.orders.title': 'Pesanan meja ini',
  'menu.orders.total': 'Total pesanan',
  'menu.orders.status.sent': 'DIKIRIM',
  'menu.orders.status.preparing': 'DIMASAK',
  'menu.orders.status.ready': 'SIAP',
  'menu.orders.status.served': 'DISAJIKAN',
  'menu.orders.status.cancelled': 'DIBATALKAN',
};
